// TODO: duplicated base colour definitions.
// We could probably user https://amzn.github.io/style-dictionary/ and define everything there.
const LMG_BLUE = '#0054A6';
const LMG_YELLOW = '#FFDD00';
const LMG_RED = '#ED1A3B';
const LMG_BLACK = '#000000';
const LMG_WHITE = '#FFFFFF';
const LMG_LIGHT_GREY = 'lightgrey';
const LMG_PLACEHOLDER_GREY = '#B8B8B8';
const LMG_DISABLED_GREY = '#666666';

const PRIMARY_COLOUR = LMG_BLUE;
const SECONDARY_COLOUR = LMG_YELLOW;
const HIGHLIGHT_COLOUR = LMG_RED;

const theme = {
  colour: {
    general: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
      highlight: HIGHLIGHT_COLOUR,
    },
    uiControls: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
    },
    text: {
      heading: {
        primary: LMG_BLUE,
      },
      content: {
        primary: LMG_BLACK,
      },
      link: {
        primary: LMG_BLUE,
      },
      menu: {
        primary: LMG_WHITE,
      },
      form: {
        textInput: {
          primary: LMG_BLUE,
          placeholder: LMG_PLACEHOLDER_GREY,
        },
      },
      drawer: {
        primary: LMG_WHITE,
      },
      button: {
        attention: LMG_YELLOW,
        disabled: LMG_DISABLED_GREY,
      },
      hero: {
        header: LMG_BLUE,
      },
      tabIcons: {
        cart: {
          priceBadge: LMG_YELLOW,
        },
      },
      tile: {
        name: LMG_BLACK,
        byline: '#666666',
        price: LMG_BLUE,
        priceSecondary: '#666666',
        button: LMG_WHITE,
      },
    },
    border: {
      general: {
        primary: PRIMARY_COLOUR,
      },
      appRoot: {
        primary: LMG_BLUE,
      },
      tile: '#CCCCCC',
    },
    icon: {
      general: {
        primary: PRIMARY_COLOUR,
        secondary: SECONDARY_COLOUR,
      },
      header: {
        primary: LMG_WHITE,
      },
    },
    background: {
      general: {
        primary: PRIMARY_COLOUR,
        contrastOnPrimary: LMG_WHITE,
        // Page background. Not contrastOnPrimary: that is BLACK on Thirsty Camel.
        screen: LMG_WHITE,
        secondary: SECONDARY_COLOUR,
      },
      button: {
        primary: PRIMARY_COLOUR,
        contrastOnPrimary: LMG_WHITE,
        disabled: LMG_LIGHT_GREY,
      },
      hero: {
        header: LMG_YELLOW,
      },
      drawer: PRIMARY_COLOUR,
      feedTile: {
        promotion: LMG_YELLOW,
      },
      range: {
        tileContainer: LMG_BLUE,
      },
      tile: {
        surface: LMG_WHITE,
        buttonDisabled: LMG_WHITE,
      },
      memberPriceBadge: LMG_YELLOW,
    },
    activityIndicator: {
      primary: PRIMARY_COLOUR,
    },
    checkbox: {
      primary: LMG_BLUE,
    },
    navTab: {
      barBg: LMG_WHITE,
      activeBg: LMG_BLUE,
      activeText: LMG_WHITE,
      inactiveText: LMG_BLUE,
    },
    desktopNavTab: {
      activeBg: LMG_WHITE,
      activeText: LMG_BLUE,
      inactiveText: LMG_WHITE,
    },
    creditCard: {
      background: LMG_BLUE,
      text: LMG_WHITE,
      textMuted: 'rgba(255,255,255,0.7)',
      chip: '#D4AF37',
    },
    // Footer (DIS-1841): darker brand blue, Figma footer/desk 476:7181.
    footer: {
      divider: '#00386F',
      legalText: '#00386F',
    },
    // Header (DIS-1840): darker brand blue, from the header prototype (DIS-1859).
    header: {
      divider: '#00386F',
      cartChip: '#00386F',
      onCartChip: LMG_WHITE,
    },
  },
  size: {
    text: {
      body1: 18,
      body2: 16,
      heading0: 24,
      heading1: 20,
      heading2: 18,
      heading3: 16,
      heading4: 14,
      caption: 14,
    },
    badge: {
      type: 'pentagon',
      color: '#ED1A3B',
      titleFontSize: 9,
      titleFontSizeLong: 8,
      priceFontSize: 18,
      dollarSignFontSize: 11,
      chevronHeight: 8,
      contentPadding: 3,
      titlePaddingVertical: 2,
      titlePaddingHorizontal: 3,
      pricePaddingVertical: 6,
      textY: 20,
      priceYWithText: 32,
      priceYNoText: 28,
    },
    // Banner geometry — DIS-1181 (web 1300×400) + DIS-1182 (mobile 760×500).
    // Stored as raw width/height; consumers derive aspectRatio = width / height.
    banner: {
      web: {width: 1300, height: 400, maxWidth: 1300, maxHeight: 400},
      mobile: {width: 760, height: 500},
    },
  },
  typography: {
    fontFamily: 'Rubik',
    fontFamilyBold: 'Rubik-Bold',
    weights: {
      light: {fileName: 'Rubik-Light', weight: 300, style: 'normal'},
      regular: {fileName: 'Rubik-Regular', weight: 400, style: 'normal'},
      medium: {fileName: 'Rubik-Medium', weight: 500, style: 'normal'},
      semiBold: {fileName: 'Rubik-SemiBold', weight: 600, style: 'normal'},
      bold: {fileName: 'Rubik-Bold', weight: 700, style: 'normal'},
      extraBold: {fileName: 'Rubik-ExtraBold', weight: 800, style: 'normal'},
    },
  },
};

export default theme;
